import {createLogger} from '../../common/logging.config';
const logger = createLogger('downloadInfo-service');

module.exports = ['$http', '$q', function($http, $q) {

    const SPA_info_Url = '/api/infra/v1/info';
	const Oslo_info_Url = '/api/infra/v1/info/sample-oslo';
    const Stockholm_info_Url = '/api/infra/v1/info/sample-stockholm';
    const SPA_deploy_Url = '/api/infra/v1/deploy';
    const Oslo_deploy_Url = '/api/infra/v1/deploy/sample-oslo';
    const Stockholm_deploy_Url = '/api/infra/v1/deploy/sample-stockholm';

    /**
	* Returns a promise to the JSON for the info of the newest Oslo/Stockholm template package that is available for download
	* @param template_name name. e.g.Oslo, Stockholm. If template_name is null, the backend API will decide the sample to show based on your tenant
	* @return {Promise}
	*/
    // return the date of latest available sample (stockholm and oslo, or others based on tenant)
	function getDownloadInfo(template_name) {
        const infoUrl =  (!template_name) 
                            ? SPA_info_Url
                            : (template_name === 'stockholm') ? Stockholm_info_Url : Oslo_info_Url;
		return $http.get(infoUrl).then(
			(res) => res.data,
			(res) => $q.reject(res.status + ' :: ' + res.statusText)
			// todo - should use res.data.errors[0].message here for more details on missing collection?
		);
    }

    /**
     * Returns a promise to the JSON for the SPA build date and its sample name, e.g. Oslo, Stockholm
     * @param domain_name, tenantID
     * @return {Promise}
     */
	// return build date of installed sample (Oslo and Stockholm)
	function getSiteBuildDate(domain_name, tenantID) {
        const dateURL = 'https://' + domain_name + '/api/' + tenantID + '/delivery/v1/resources?path=/buildDate.json';
        return $http.get(dateURL).then(
            (res) => res.data,
            (res) => $q.reject(res.status + ' :: ' + res.statusText)
        );

    }

    /**
     * Kicks off Deploy API to delete all your content and deploy the newest sample(Stockholm, Oslo) to your tenant 
	 * @param template_name name. e.g.Oslo, Stockholm. If template_name is null, the backend API will decide the sample to show based on your tenant
     * @return {Promise}
     */
    function getDeploySite(template_name) {
        const deployUrl =  (!template_name) 
                            ? SPA_deploy_Url
                            : (template_name === 'stockholm') ? Stockholm_deploy_Url : Oslo_deploy_Url;
        return $http.get(deployUrl).then(
            (res) => res.data,
            (res) => $q.reject(res.status + ' :: ' + res.statusText)
            // todo - should use res.data.errors[0].message here for more details on missing collection?
        );
    }
	
	// return public API for the REST factory
    return {
        getDownloadInfo: getDownloadInfo,
        getSiteBuildDate: getSiteBuildDate,
        getDeploySite: getDeploySite
    };
}];



// WEBPACK FOOTER //
// ./app/common/services/downloadInfo-service.factory.js